// extracted by mini-css-extract-plugin
module.exports = {"menuPage":"ResourcesMenu_menuPage__Ecxjr","menuContent":"ResourcesMenu_menuContent__Qw2dv"};